/**
 * Tutorial slides configuration for all pages
 * Used by OnboardingTutorial component
 */
import { 
  Star, Activity, Zap, Camera, Target, Shield, Bell, Crown, 
  PiggyBank, TrendingUp, BookOpen, BarChart3, Search, FileText,
  Calculator, Scale, Percent, Calendar, AlertTriangle, DollarSign
} from 'lucide-react';

// ==================== MES MARCHÉS (Watchlist) ====================
export const WATCHLIST_SLIDES = [
  {
    icon: Star,
    title: "Votre Watchlist",
    description: "Ajoutez vos actifs favoris (Crypto, Actions, Forex, Indices) pour suivre leurs performances en temps réel. Cliquez sur \"+\" pour ajouter un symbole."
  },
  {
    icon: Activity,
    title: "Suivi en Direct",
    description: "Consultez les prix, variations 24h et tendances de tous vos actifs au même endroit."
  },
  {
    icon: Target,
    title: "Analyse Rapide",
    description: "Cliquez sur le bouton \"Analyser\" d'un actif pour lancer directement une analyse IA depuis le Scan Auto."
  }
];

// ==================== ANALYSE IA ====================
export const ANALYSIS_SLIDES = [
  {
    icon: Camera,
    title: "Deux Modes d'Analyse",
    description: "Auto : Les graphiques sont générés automatiquement. Manuel : Importez vos propres captures TradingView avec vos indicateurs personnalisés."
  },
  {
    icon: Target,
    title: "Analyse ICT Avancée",
    description: "L'IA détecte les Order Blocks, Fair Value Gaps, zones de liquidité et structure de marché pour proposer des entrées optimales."
  },
  {
    icon: TrendingUp,
    title: "Entrée Optimale vs Au Marché",
    description: "Entrée Optimale : Vous recevrez une alerte quand le prix atteint la zone idéale. Validez ensuite le trade pour qu'il passe \"en cours\" dans votre Journal. Entrée Au Marché : Le trade est actif immédiatement au prix actuel."
  },
  {
    icon: Shield,
    title: "Résultats Personnalisés",
    description: "L'analyse s'adapte automatiquement à votre profil de risque défini lors de votre inscription."
  }
];

// ==================== SCAN AUTO ====================
export const SCAN_AUTO_SLIDES = [
  {
    icon: Star,
    title: "Actifs Prioritaires",
    description: "Sélectionnez vos actifs prioritaires pour qu'ils soient analysés automatiquement chaque jour à 16h (heure de Paris)."
  },
  {
    icon: Crown,
    title: "Limites par Abonnement",
    description: "Pro : 3 actifs prioritaires (modifiable 2 fois/mois) • Expert : 10 actifs prioritaires (modifications illimitées)"
  },
  {
    icon: Bell,
    title: "Alertes Intelligentes",
    description: "Recevez une notification push quand un setup de qualité est détecté sur l'un de vos actifs surveillés."
  }
];

// ==================== DCA ====================
export const DCA_SLIDES = [
  {
    icon: PiggyBank,
    title: "DCA Intelligent",
    description: "Le Dollar Cost Averaging vous permet d'investir progressivement pour lisser votre prix d'entrée et réduire le risque."
  },
  {
    icon: Star,
    title: "Zones OTE",
    description: "Les zones OTE (Optimal Trade Entry) basées sur Fibonacci (61.8%-78.6%) sont les meilleures zones d'achat. Elles s'illuminent quand le prix y entre !"
  },
  {
    icon: Bell,
    title: "Alertes Prix",
    description: "Activez les notifications pour être alerté quand le prix entre dans une zone d'achat de votre plan DCA."
  }
];

// ==================== JOURNAL (History) ====================
export const HISTORY_SLIDES = [
  {
    icon: BarChart3,
    title: "Suivi de Performance",
    description: "Consultez l'historique complet de vos trades avec statistiques détaillées : Win Rate, PnL total, meilleur/pire trade."
  },
  {
    icon: Search,
    title: "Filtres Avancés",
    description: "Filtrez par type (Swing/Intraday), résultat (Gagnant/Perdant), statut ou période pour analyser vos performances."
  },
  {
    icon: FileText,
    title: "Paper Trading",
    description: "Testez vos stratégies sans risque avec le mode Paper Trading. Capital virtuel de 10 000$ pour apprendre."
  }
];

// ==================== CALCULATEUR ====================
export const CALCULATOR_SLIDES = [
  {
    icon: DollarSign,
    title: "Calcul de Position",
    description: "Calculez automatiquement la taille de position optimale en fonction de votre capital et pourcentage de risque."
  },
  {
    icon: Scale,
    title: "Gestion du Risque",
    description: "Le calculateur respecte la règle d'or : ne jamais risquer plus de 1-2% du capital par trade."
  },
  {
    icon: Percent,
    title: "R:R Automatique",
    description: "Visualisez le ratio Risk:Reward et les gains potentiels à chaque niveau de Take Profit (TP1, TP2, TP100)."
  }
];

// ==================== NEWS ÉCO ====================
export const NEWS_ECO_SLIDES = [
  {
    icon: Calendar,
    title: "Calendrier Économique",
    description: "Suivez les événements économiques majeurs (NFP, CPI, FOMC, BCE) qui impactent les marchés."
  },
  {
    icon: AlertTriangle,
    title: "Impact & Volatilité",
    description: "Les événements sont classés par niveau d'impact (🟢 faible, 🟡 moyen, 🔴 élevé). Évitez de trader pendant les annonces majeures."
  },
  {
    icon: Bell,
    title: "Alertes Résultats",
    description: "Recevez une notification quand les résultats sont publiés avec comparaison Attendu vs Réel."
  }
];

// ==================== FORMATION ====================
export const LEARN_SLIDES = [
  {
    icon: BookOpen,
    title: "Concepts ICT",
    description: "Apprenez les bases du trading institutionnel : Order Blocks, Fair Value Gaps, Liquidity Sweeps, Market Structure."
  },
  {
    icon: TrendingUp,
    title: "Modules Progressifs",
    description: "Du débutant à l'expert, suivez les modules dans l'ordre pour maîtriser chaque concept avant de passer au suivant."
  }
];

export default {
  watchlist: WATCHLIST_SLIDES,
  analysis: ANALYSIS_SLIDES,
  scanAuto: SCAN_AUTO_SLIDES,
  dca: DCA_SLIDES,
  history: HISTORY_SLIDES,
  calculator: CALCULATOR_SLIDES,
  newsEco: NEWS_ECO_SLIDES,
  learn: LEARN_SLIDES
};
